import { action } from "./instructions.js";
import { call } from "./call.js";
/**
 * @deprecated use {@link call} instead
 */
export function expect(promise) {
    return action(function* (resolve, reject) {
        promise.then(resolve, reject);
    });
}
export function subscribe(iter) {
    return {
        next: () => call(() => iter.next()),
    };
}
export function stream(iterable) {
    return {
        *subscribe() {
            return subscribe(iterable[Symbol.asyncIterator]());
        },
    };
}
//# sourceMappingURL=async.js.map